/**
 * @see https://codepen.io/ruandre/pen/howFi
 */

import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const Email: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--email')}
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <path
      fill="black"
      stroke="black"
      d="
        M101.3 141.6
        v228.9h0.3 308.4 0.8
        V141.6H101.3
        z
        M375.7 167.8
        l-119.7 91.5 -119.6-91.5
        H375.7
        z
        M127.6 194.1
        l64.1 49.1 -64.1 64.1
        V194.1
        z
        M127.8 344.2
        l84.9-84.9 43.2 33.1 43-32.9 84.7 84.7
        L127.8 344.2 127.8 344.2
        z
        M384.4 307.8
        l-64.4-64.4 64.4-49.3
        V307.8
        z
      "
    />
  </svg>
);

export default Email;
